"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1915],{

/***/ 15702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loan_calculator; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./shared/components/select-field/index.tsx
var select_field = __webpack_require__(75983);
// EXTERNAL MODULE: ./shared/components/text-field/index.tsx + 2 modules
var text_field = __webpack_require__(22900);
// EXTERNAL MODULE: ./shared/components/mask-components/index.tsx
var mask_components = __webpack_require__(95114);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box_Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(91346);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./shared/components/range-slider-field/index.tsx




var _excluded = ["children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function valuetext(value) {
  return "".concat(value, "\xB0C");
}

function RangeSlider(props) {
  var _useField = (0,formik_esm/* useField */.U$)({
    name: props.name
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var _React$useState = react.useState(props.defaultValue),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      values = _React$useState2[0],
      setValue = _React$useState2[1];

  var debounceHandle = function debounceHandle(event, newValue) {// props.onChange(newValue as number);
  };

  var debouncedChangeHandler = react.useCallback((0,lodash.debounce)(debounceHandle, 100), []); // sleep()

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
    helpers.setValue(newValue);
    debouncedChangeHandler(event, newValue);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Content, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomSlider, {
    name: props.name,
    value: values,
    onChange: handleChange,
    valueLabelDisplay: "auto",
    min: props.min,
    max: props.max,
    components: {
      Thumb: function Thumb(e) {
        return (0,emotion_react_browser_esm/* jsx */.tZ)(ThumbComponent, (0,esm_extends/* default */.Z)({}, e, {
          percent: props.initialPaymentPercent
        }));
      }
    },
    getAriaValueText: valuetext
  }));
}

function ThumbComponent(props) {
  var children = props.children,
      other = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Slider/* SliderThumb */.gs, other, children, (0,emotion_react_browser_esm/* jsx */.tZ)(Thumblabel, null, props.percent + '%'));
}

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Box_Box/* default */.Z,  true ? {
  target: "e1cbj2ve9"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var shareStylesThumbIcon =  true ? {
  name: "1wiuhaw",
  styles: "width:9px;height:9px;color:#fff;font-weight:bold"
} : 0;

var ThumbIconLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(ArrowBackIosNewRoundedIcon,  true ? {
  target: "e1cbj2ve8"
} : 0)(shareStylesThumbIcon, ";" + ( true ? "" : 0))));

var ThumbIconRight = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(ArrowForwardIosRoundedIcon,  true ? {
  target: "e1cbj2ve7"
} : 0)(shareStylesThumbIcon, ";" + ( true ? "" : 0))));

var shareStylesContent =  true ? {
  name: "zov8s0",
  styles: "width:100%;display:flex;justify-content:center"
} : 0;

var Thumblabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1cbj2ve6"
} : 0)( true ? {
  name: "1gy9dpq",
  styles: "color:#fff;font-weight:bold;font-size:10px;display:block;text-align:center"
} : 0);

var ContentDescription = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(Box,  true ? {
  target: "e1cbj2ve5"
} : 0)(shareStylesContent, ";" + ( true ? "" : 0))));

var LabelDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1cbj2ve4"
} : 0)( true ? {
  name: "1e5uawc",
  styles: "color:var(--color-brand-grey-main);font-size:14px"
} : 0);

var ContentValue = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(Box,  true ? {
  target: "e1cbj2ve3"
} : 0)("margin-top:5px;", shareStylesContent, ";" + ( true ? "" : 0))));

var LabelValue = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1cbj2ve2"
} : 0)( true ? {
  name: "1bgdim9",
  styles: "color:var(--color-brand-blue-main);font-size:15px;font-weight:600;white-space:nowrap"
} : 0);

var LabelValuePrice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1cbj2ve1"
} : 0)( true ? {
  name: "14ol4nx",
  styles: "color:var(--color-brand-blue-main);font-size:16px;font-weight:600;text-transform:uppercase"
} : 0);

var CustomSlider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Slider/* default */.ZP,  true ? {
  target: "e1cbj2ve0"
} : 0)( true ? {
  name: "ieg541",
  styles: "& .MuiSlider-rail{color:var(--color-brand-grey-secondary);height:9px;}& .MuiSlider-track{background-color:var(--color-brand-red-main);border-color:var(--color-brand-red-main);height:8px;}& .MuiSlider-thumb{pointer-events:none;height:40px;width:40px;background-color:var(--color-brand-red-main);border:\"none\";outline:8px solid #fff;color:#000;&:hover,&:active{box-shadow:none;}& .MuiSlider-valueLabel{display:none;}}"
} : 0);
;// CONCATENATED MODULE: ./shared/components/loan-calculator/index.tsx



function loan_calculator_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var loanDurationOptions = [{
  value: 10,
  label: "10 años"
}, {
  value: 15,
  label: "15 años"
}, {
  value: 20,
  label: "20 años"
}, {
  value: 25,
  label: "25 años"
}, {
  value: 30,
  label: "30 años"
}, {
  value: 35,
  label: "35 años"
}, {
  value: 40,
  label: "40 años"
}];

function LoanCalculator(props) {
  var AmountDataLabel = function AmountDataLabel(props) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      className: "amountDataLabel amountDataLabel--" + props.data.classModifier
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      className: "amountDataLabel__title"
    }, props.data.title), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      className: "amountDataLabel__amount"
    }, props.data.prefix + parseInt(props.data.amount).toLocaleString(undefined, {
      maximumFractionDigits: 2
    })), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      className: "amountDataLabel__percent"
    }, translation("percent") + " ".concat(props.data.percent, "%")));
  };

  var handleSubmit = function handleSubmit(values) {
    if (props.onSubmit) {
      props.onSubmit(values);
    }
  };

  var translation = (0,next_intl_cjs_production_min.useTranslations)("mortgageCalculator.calculatorForm");
  var title = translation("title") || "";

  var _title$split = title.split(" "),
      _title$split2 = (0,toArray/* default */.Z)(_title$split),
      first = _title$split2[0],
      rest = _title$split2.slice(1);

  var _props$initialPrice = props.initialPrice,
      initialPrice = _props$initialPrice === void 0 ? "" : _props$initialPrice,
      _props$currency = props.currency,
      currency = _props$currency === void 0 ? {
    iso: "RD",
    symbol: "RD"
  } : _props$currency,
      _props$disableLoanAmo = props.disableLoanAmount,
      disableLoanAmount = _props$disableLoanAmo === void 0 ? false : _props$disableLoanAmo;
  var initialPay = parseInt(initialPrice) * 0.3;
  var defaultValues = {
    initialPayment: initialPay.toString(),
    loanAmount: (parseInt(initialPrice) - initialPay).toString(),
    bankRate: "10.20",
    loanDuration: 20
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, first, " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, rest.join(" "))), (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Formik */.J9, {
    enableReinitialize: true,
    initialValues: defaultValues,
    onSubmit: handleSubmit
  }, function (formikProps) {
    var _formikProps$values = formikProps.values,
        bankRate = _formikProps$values.bankRate,
        loanDuration = _formikProps$values.loanDuration,
        initialPayment = _formikProps$values.initialPayment,
        loanAmount = _formikProps$values.loanAmount;
    var loanAmountValue = parseFloat(initialPrice || loanAmount) - parseFloat(initialPayment || "0");
    var monthlyBankRate = parseFloat(bankRate) / 12 / 100;
    var duration = parseInt(loanDuration) * 12;
    var loan = (loanAmountValue * monthlyBankRate / (1 - Math.pow(1 + monthlyBankRate, -1 * duration))).toFixed(2);
    var initialPaymentPercent = parseFloat(initialPayment) * 100 / parseFloat(initialPrice);

    if (initialPaymentPercent > 100.00) {
      initialPaymentPercent = 100;
    }

    initialPaymentPercent = parseFloat(initialPaymentPercent.toFixed(0));
    var loanAmountPercent = (loanAmountValue * 100 / parseFloat(initialPrice)).toLocaleString(undefined, {
      maximumFractionDigits: 0
    });
    var dataAmountLabel = {
      initialPay: {
        classModifier: 'initial',
        title: translation("initialPayment"),
        percent: isNaN(initialPaymentPercent) ? 0 : initialPaymentPercent,
        amount: initialPayment != '' ? initialPayment : '0',
        prefix: currency.symbol + "$"
      },
      loanAmount: {
        classModifier: 'amount',
        title: translation("loanAmount"),
        percent: loanAmountPercent == 'NaN' || parseInt(loanAmountPercent) < 0 ? 0 : loanAmountPercent,
        amount: loanAmountValue > 0 ? loanAmountValue : 0,
        prefix: currency.symbol + "$"
      },
      minValue: parseInt(initialPrice) * 0.2,
      maxValue: parseInt(initialPrice) * 0.8,
      defaultValues: initialPay
    };
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(InputWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
      name: "bankRate",
      label: translation("bankRate"),
      inputComponent: mask_components/* PercentInput */.H3,
      placeholder: "Ej: % 12.95"
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(InputWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(select_field/* default */.Z, {
      name: "loanDuration",
      label: translation("loanDuration"),
      items: loanDurationOptions
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(InputRangeWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(RangeLabelLeft, null, translation("initialPayment")), (0,emotion_react_browser_esm/* jsx */.tZ)(RangeLabelRight, null, translation("loanAmount")), (0,emotion_react_browser_esm/* jsx */.tZ)(RangeSlider, {
      onChange: function onChange(e) {},
      value: dataAmountLabel.defaultValues,
      name: "initialPayment",
      min: dataAmountLabel.minValue,
      max: dataAmountLabel.maxValue,
      defaultValue: dataAmountLabel.defaultValues,
      initialPaymentPercent: dataAmountLabel.initialPay.percent
    })), disableLoanAmount && (0,emotion_react_browser_esm/* jsx */.tZ)(LoanAmount, {
      type: "hidden",
      name: "loanAmount",
      inputComponent: mask_components/* MoneyInput */.PK,
      disabled: disableLoanAmount,
      value: loanAmountValue > 0 ? loanAmountValue : 0
    }), !disableLoanAmount && (0,emotion_react_browser_esm/* jsx */.tZ)(LoanAmount, {
      type: "hidden",
      name: "loanAmount",
      inputComponent: mask_components/* MoneyInput */.PK
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(InputWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AmountDataLabel, {
      data: dataAmountLabel.initialPay
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(InputWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AmountDataLabel, {
      data: dataAmountLabel.loanAmount
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(Footer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Result, {
      finalAmount: loan
    }, translation("estimate"), (0,emotion_react_browser_esm/* jsx */.tZ)(Amount, null, (0,emotion_react_browser_esm/* jsx */.tZ)(mask_components/* MoneyInput */.PK, {
      value: parseFloat(loan) > 0 ? loan : 0,
      prefix: currency.symbol + "$",
      displayType: "text"
    }))), (0,emotion_react_browser_esm/* jsx */.tZ)(SubmitButton, {
      type: "submit",
      className: "solicitar-prestamo-hipotecario"
    }, translation("request"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Details, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsText, null, translation("description")), (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsText, null, translation("info"))));
  }));
}

var sharedCss =  true ? {
  name: "162c73d",
  styles: "display:flex;align-items:center;font-weight:700;color:var(--color-brand-bg-secondary)"
} : 0;
var rangeLabelSharedCss =  true ? {
  name: "1i5ac87",
  styles: "font-size:13px;color:var(--color-brand-grey-main);font-weight:bold;margin-bottom:15px"
} : 0;

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(formik_esm/* Form */.l0,  true ? {
  target: "e1jz40a512"
} : 0)( true ? {
  name: "1nnhxt9",
  styles: "margin:40px auto 0;display:flex;max-width:800px;justify-content:space-between;flex-wrap:wrap"
} : 0);

var InputWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jz40a511"
} : 0)( true ? {
  name: "ego991",
  styles: "width:45%;margin-bottom:20px;min-width:45%;& .amountDataLabel{width:100%;padding:20px 5px 20px 10px;border-radius:15px;color:#fff;& span{display:block;}&--amount,&--initial{margin-bottom:30px;&::before{content:\"\";width:56px;height:70px;display:block;float:left;margin-right:10px;background-position:center;background-size:80%;background-repeat:no-repeat;}}&--initial{background-color:var(--color-brand-blue-main);&::before{background-image:url(/icons/money_icon_remax.svg);}}&--amount{background-color:#9E9FA3;&::before{background-image:url(/icons/bank_icon_remax.svg);}}&__title{font-weight:bold;font-size:16px;}&__amount{font-weight:bold;font-size:28px;margin-bottom:5px;}&__percent{font-size:16px;font-style:italic;}}@media screen and (max-width: 868px){& .amountDataLabel{&__amount{font-size:26px;}}}@media screen and (max-width: 767px){width:100%;& .amountDataLabel{max-width:450px;margin:0 auto;&__title,&__percent{font-size:14px;}}}@media screen and (max-width: 375px){& .amountDataLabel{&__amount{font-size:22px;}}}"
} : 0);

var InputRangeWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jz40a510"
} : 0)( true ? {
  name: "1iel2lg",
  styles: "width:100%;margin:0 0 20px;padding:0 5px"
} : 0);

var RangeLabelLeft = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1jz40a59"
} : 0)(rangeLabelSharedCss, ";" + ( true ? "" : 0));

var RangeLabelRight = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1jz40a58"
} : 0)(rangeLabelSharedCss, " float:right;" + ( true ? "" : 0));

var Footer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jz40a57"
} : 0)(sharedCss, " width:100%;margin-bottom:50px;@media screen and (max-width: 767px){flex-direction:column;}" + ( true ? "" : 0));

var Result = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jz40a56"
} : 0)(sharedCss, " font-size:1.1rem;width:75%;background-color:var(--color-brand-red-main);justify-content:center;border-radius:50px;position:relative;", function (props) {
  if (props.finalAmount.toString().length >= 7) {
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      (0,emotion_react_browser_esm/* css */.iv)("flex-direction:column;text-align:center;", Amount, "{margin:0;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0)
    );
  }
}, "@media screen and (max-width: 767px){font-size:1rem;padding:20px 0 10px;height:auto;width:100%;flex-direction:column;}" + ( true ? "" : 0));

var SubmitButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1jz40a55"
} : 0)(sharedCss, " background-color:var(--color-brand-blue-tertiary);font-size:1.1rem;font-weight:700;width:30%;height:60px;border-radius:50px;justify-content:center;margin-left:-6%;border:none;cursor:pointer;font-family:var(--font-family);line-height:1.15;@media screen and (max-width: 767px){margin:0;margin-top:20px;width:200px;}" + ( true ? "" : 0));

var LoanAmount = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(text_field/* default */.Z,  true ? {
  target: "e1jz40a54"
} : 0)( true ? {
  name: "eivff4",
  styles: "display:none"
} : 0);

var Amount = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1jz40a53"
} : 0)( true ? {
  name: "c7vt9l",
  styles: "font-size:2.9rem;font-weight:700;color:var(--color-brand-bg-secondary);margin-left:30px;@media screen and (max-width: 767px){font-size:1.9rem;margin-left:0;margin-top:5px;}"
} : 0);

var Details = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jz40a52"
} : 0)( true ? {
  name: "15ru7o6",
  styles: "text-align:center;color:var(--color-brand-grey-main)"
} : 0);

var DetailsText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1jz40a51"
} : 0)( true ? {
  name: "1dm6pds",
  styles: "font-size:0.7rem;color:var(--color-brand-grey-main);font-weight:400;margin-bottom:50px;&:first-of-type{font-size:0.8rem;font-weight:500;}"
} : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1jz40a50"
} : 0)( true ? {
  name: "4zveqx",
  styles: "font-size:28.8px;color:black;margin-bottom:1.5rem;&>span{font-weight:300;}"
} : 0);

var initialValues = {
  bankRate: "",
  loanDuration: "",
  initialPayment: "",
  loanAmount: ""
};
/* harmony default export */ var loan_calculator = (LoanCalculator);

/***/ }),

/***/ 75983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17674);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18360);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18972);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _label_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78836);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);




var _excluded = ["label", "itemLabel", "itemValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function SelectField(props) {
  var _field$value, _props$items;

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useField */ .U$)(props),
      _useField2 = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var label = props.label,
      itemLabel = props.itemLabel,
      itemValue = props.itemValue,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  var config = _objectSpread(_objectSpread(_objectSpread({}, field), rest), {
    id: props.name
  });

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
    css: styles.contentInput
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_label_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    label: props.label,
    positionLabel: props.positionLabel
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    css: styles.inputField
  }, config, {
    value: (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : -1
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    value: -1,
    disabled: true
  }, props.placeholder), !props.children && ((_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.map(function (item, i) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      key: i,
      value: itemValue ? item[itemValue] : item.value
    }, itemLabel ? item[itemLabel] : item.label);
  })), (props === null || props === void 0 ? void 0 : props.children) && props.children), meta.error && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
    css: styles.inputErrors
  }, meta.error));
}

/* harmony default export */ __webpack_exports__["Z"] = (SelectField);
var styles = {
  inputField:  true ? {
    name: "1fjye5c",
    styles: "width:100%;outline:none;border-radius:50px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:600;font-size:var( --fs-body-small);line-height:21px;& .MuiSelect-outlined::focus-visible{border:0px !important;}& .MuiOutlinedInput-notchedOutline{border:1px solid var(--color-brand-border);top:-8px;}&:hover .MuiOutlinedInput-notchedOutline{border:1px solid var(--color-brand-blue-collection-main);}& .MuiOutlinedInput-input{padding:12px 23px !important;}&::placeholder{font-family:var(--font-family);font-weight:600;font-size:var( --fs-body-small);color:var(--color-brand-blue-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};

/***/ }),

/***/ 57626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Creates a canonical URL by removing unnecessary query parameters
 * @param url - The original URL
 * @param keepParams - Optional array of parameter names to keep
 * @returns A clean canonical URL
 */
var prepareUrl = function prepareUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    // Handle empty or invalid URLs
    if (!url || typeof url !== "string") return ""; // For relative URLs, prepend with origin

    var isRelative = !url.startsWith("http");
    var baseUrl =  true ? window.location.origin : 0;
    var fullUrl = isRelative ? "".concat(baseUrl).concat(url.startsWith("/") ? "" : "/").concat(url) : url; // Parse the URL

    var urlObject = new URL(fullUrl); // If no params to keep, return without query string

    if (!keepParams.length) {
      return "".concat(urlObject.origin).concat(urlObject.pathname);
    } // Create a new URLSearchParams object to manipulate parameters


    var params = new URLSearchParams(); // Only keep specified parameters

    keepParams.forEach(function (param) {
      var value = urlObject.searchParams.get(param);

      if (value) {
        params.set(param, value);
      }
    }); // Build the canonical URL

    var queryString = params.toString();
    return "".concat(urlObject.origin).concat(urlObject.pathname).concat(queryString ? "?".concat(queryString) : "");
  } catch (error) {
    // Fallback method
    try {
      var questionMarkIndex = url.indexOf("?");

      if (questionMarkIndex === -1 || !keepParams.length) {
        // No query params or nothing to keep
        return questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
      } // Manual parsing for fallback


      var base = url.substring(0, questionMarkIndex);
      var query = url.substring(questionMarkIndex + 1);
      var pairs = query.split("&");
      var filteredPairs = pairs.filter(function (pair) {
        var key = pair.split("=")[0];
        return keepParams.includes(key);
      });
      return filteredPairs.length > 0 ? "".concat(base, "?").concat(filteredPairs.join("&")) : base;
    } catch (_unused) {
      return url; // Return original if all else fails
    }
  }
};

var createCanonicalUrl = function createCanonicalUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var urlresolve = prepareUrl(url, keepParams); // console.log(urlresolve);

  return urlresolve;
};

/* harmony default export */ __webpack_exports__["Z"] = (createCanonicalUrl);

/***/ })

}]);